<label *ngIf="showLabel" [for]="name" class="text-sm text-gray-600 tracking-wide mb-2">{{ name }}</label>
<div class="relative">
    <input *ngIf=" !isTextArea && !isEditor;else textArea" [id]="name" [name]="name" [disabled]="disabled"
        [type]="inputType" [placeholder]="showPlaceholder ? name : ''" [(ngModel)]="value" (blur)="blur.emit()"
        (focus)="focus.emit()"
        [inputMask]="inputMask"
        class="w-full rounded border text-sm placeholder-gray-400 focus:border-purple-400 focus:outline-none disabled:text-gray-600 px-3 py-2"
        [class.border-red-400]="hasError" />
</div>
<ng-template #textArea>
    <textarea *ngIf="!isEditor; else editor" [id]="name" [name]="name" [disabled]="disabled"
        [placeholder]="showPlaceholder ? name : ''" [(ngModel)]="value" (blur)="blur.emit()" (focus)="focus.emit()"
        class="w-full rounded border text-sm placeholder-gray-400 focus:border-purple-400 focus:outline-none disabled:text-gray-600 px-3 py-2"
        [class.border-red-400]="hasError"></textarea>
</ng-template>
<div class="h-4 pt-1">
    <app-input-errors *ngIf="hasError" [errors]="ngControl?.control?.errors!"></app-input-errors>
</div>

<ng-template #editor>
    <editor (onInit)="onInit($event)" [(ngModel)]="value" [init]="editorSettings" class="mt-2 col-span-2">
    </editor>
</ng-template>
